import { render, staticRenderFns } from "./ModalProvinceManage.vue?vue&type=template&id=1abda593&"
import script from "./ModalProvinceManage.vue?vue&type=script&lang=js&"
export * from "./ModalProvinceManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports